<template>
    <div class="fullscreen-button">
        <span
            :class="{
                'icon-fullscreen': !fullscreenEnabled,
                'icon-fullscreen_exit': fullscreenEnabled
            }"
        ></span>
    </div>
</template>

<script lang="ts">
export default {
    name: "FullscreenButton",
    props: {
        fullscreenEnabled: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>

<style scoped>
.fullscreen-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 2em;
    font-weight: bold;
    text-decoration: none;
    background-color: rgba(100, 100, 100, 0.5);
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
}
</style>
